import { isSignal } from '@angular/core';
import { ValueOrFactory } from './type.utils';

/** Simple helper that will resolve a raw value or a factory */
export function resolveSimpleFactory<T>(value: ValueOrFactory<T>): T {
  if (isSignal(value)) {
    return value; // a signal is NOT a factory but it is a function
  } else if (typeof value === 'function') {
    return (value as () => T)();
  } else {
    return value;
  }
}
